import {useContext} from 'react'
import {Context} from '../contexts/SushiProvider'
import {Sushi} from "../sushi";

const useSushi = () => {
    const {sushi} = useContext(Context);
    return sushi
};

export default useSushi
